module.exports = __webpack_public_path__ + "img/promo.183e703f.png";